import { ID, NewTask } from '@griply/types';

import { newTaskConverter } from '../converters';
import { dateToFirestoreTimestamp } from '../converters/date-to-firestore-timestamp';
import { withRoles } from '../utils/with-roles';

export const buildTaskDocument = <
  TDocRef extends { id: ID },
  TFieldValue,
  TTimestamp,
>(
  task: NewTask,
  docRef: TDocRef,
  userId: ID,
  serverTimestamp: () => TFieldValue,
  timestampFromDate: (date: Date) => TTimestamp,
  parentIds: ID[] | null,
): Record<string, unknown> => {
  const converted = withRoles(newTaskConverter(task), userId);
  const firestoreData = dateToFirestoreTimestamp(converted, timestampFromDate);

  return {
    ...firestoreData,
    id: docRef.id,
    updatedAt: serverTimestamp(),
    parentIds,
  };
};
